export default __webpack_public_path__ + "static/media/profileImg3.18a10a11.png";